// =============================
// Imports
// =============================

import { Component } from 'react';
import PropTypes from 'prop-types';
import { Notification } from '@mewo/components';

// =============================
// Component
// =============================

class FinalNotification extends Component {
  static propTypes = {
    // Type can be 'error', 'success' or 'warning'
    type: PropTypes.oneOf(['error', 'success', 'warning']).isRequired,
    // The notification can stop showing after a while
    // Duration should be expressed in milliseconds
    duration: PropTypes.number,
    // Key of notification
    notificationKey: PropTypes.string.isRequired,
    // This component can clear notification on its own
    clearNotification: PropTypes.func.isRequired,
    // Message
    message: PropTypes.string,
    // Request ID
    reqId: PropTypes.string,
    // Translations
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    duration: 6000,
    message: '',
    reqId: '',
  };

  componentDidMount() {
    const { duration, notificationKey, clearNotification } = this.props;

    // Clear the notification after duration
    if (duration === Infinity) return;

    this.timeout = setTimeout(() => {
      clearNotification(notificationKey);
    }, duration);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  hide = () => {
    const { notificationKey, clearNotification } = this.props;
    clearTimeout(this.timeout);
    clearNotification(notificationKey);
  };

  render() {
    const { type, notificationKey, message, reqId, t } = this.props;

    return (
      <Notification
        type={type}
        onClick={() => {
          this.hide(notificationKey);
        }}
        lang={{ reqId: t('common:misc.req_id') }}
        reqId={reqId}
        className="ignore-react-onclickoutside"
      >
        {message}
      </Notification>
    );
  }
}

export default FinalNotification;
